import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import * as createProjectTeamMemberTypes from 'src/actions/project/team-member/create/Types';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';
import {
  createProjectTeamMember,
  CreateProjectTeamMemberAction,
  CreateProjectTeamMemberSuccess
} from 'src/actions/project/team-member/create/CreateProjectTeamMember.actions';
import ProjectTeamMembersFormComponent, {
  ProjectTeamMembersFormComponentProps
} from 'src/modules/project/update/partials/round-information/ProjectTeamMembersForm.component';
import { changeProjectData, ChangeProjectDataAction } from 'src/actions/project/change-data/ChangeProjectData.actions';
import Base64Encoder from 'src/services/encoders/Base64Encoder';
import ProjectData from 'src/value-objects/ProjectData';

interface StateProps {
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  createProjectTeamMember(projectId: string, teamMember: ProjectTeamMember): Promise<CreateProjectTeamMemberAction>;

  changeProjectData(project: ProjectData): ChangeProjectDataAction;
}

interface OwnProps {
  project: ProjectData;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

interface State {
  teamMember?: ProjectTeamMember;
}

class ProjectTeamMembersFormContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      teamMember: new ProjectTeamMember({
        fullName: '',
        jobTitle: '',
        description: ''
      })
    };
  }

  public render(): React.ReactNode {
    return (
      this.props.project ?
        <ProjectTeamMembersFormComponent {...this.getComponentProps()} /> :
        null
    );
  }

  private handleRichEditor(key: string): (html: string) => void {
    return (
      (html: string) => {
        let newData = {...this.state.teamMember!, [key]: html};
        this.setState({teamMember: newData});
      }
    );
  }

  private handleChange(key: string): (value: string | File) => void {
    switch (key) {
      case 'profilePicture':
        return (
          (value: File) => {
            Base64Encoder.encode(value).then((result) => {
              let newImage = {
                url: URL.createObjectURL(value),
                encoded: result.split('base64,')[1],
                ext: value.type.split('/')[1],
                name: value.name
              };
              let newData = this.state.teamMember!;
              newData.profilePicture = newImage;
              this.setState({teamMember: newData});
            });
          }
        );
      default:
        return (
          (value: string) => {
            let newData = {...this.state.teamMember!, [key]: value};
            this.setState({teamMember: newData});
          }
        );
    }
  }

  private handleSubmit(): void {
    this.props.createProjectTeamMember(this.props.project.id.toString(), this.state.teamMember!).then(
      (response: CreateProjectTeamMemberSuccess) => {
        if (response.type === createProjectTeamMemberTypes.CREATE_PROJECT_TEAM_MEMBER_SUCCESS) {
          // tslint:disable-next-line:no-any
          ($('#new-team-member') as any).collapse('toggle');
          let newTeamMember = new ProjectTeamMember(response.payload);
          newTeamMember.profilePicture = this.state.teamMember!.profilePicture;
          let newData = this.props.project;
          newData.teamMembers.push(newTeamMember);
          this.props.changeProjectData(new ProjectData(newData));
          this.setState({
            teamMember: new ProjectTeamMember({
              fullName: '',
              jobTitle: '',
              description: ''
            })
          });
        }
      }
    );
  }

  private getComponentProps(): ProjectTeamMembersFormComponentProps {
    return {
      handleChange: (key: string) => this.handleChange(key),
      handleRichEditor: (key: string) => this.handleRichEditor(key),
      handleSubmit: () => this.handleSubmit(),
      project: this.props.project!,
      newTeamMember: this.state.teamMember!,
      errorMessage: this.props.errorMessage,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  createProjectTeamMember: (projectId: string, teamMember: ProjectTeamMember):
    Promise<CreateProjectTeamMemberAction> => (
    dispatch(createProjectTeamMember(projectId, teamMember))
  ),
  changeProjectData: (project: ProjectData): ChangeProjectDataAction => (
    dispatch(changeProjectData(project))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  error: state.createProjectTeamMember.error,
  errorMessage: state.createProjectTeamMember.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTeamMembersFormContainer);
// tslint:disable-next-line no-any
($('#new-team-member') as any).collapse('toggle');



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectTeamMembersForm.container.tsx